import type { Job } from "@kanda-libs/ks-frontend-services";

export interface FormattedCustomerDetails {
  name: string;
  email: string;
  phone: string;
  address: string;
  addressLine1?: string;
  postCode?: string;
  city?: string;
}

export const formatCustomer = (
  customer: Job["customer"]
): FormattedCustomerDetails => {
  const name = customer?.first_name
    ? `${customer?.first_name} ${customer?.last_name}`
    : "No customer added";
  const address = [
    customer?.address?.line_1,
    customer?.address?.line_2,
    customer?.address?.city,
    customer?.address?.postcode,
  ]
    ?.filter(Boolean)
    ?.join(", ");
  return {
    name,
    email: customer?.email || "No email added",
    phone: customer?.phone || "No phone added",
    address: address || "No address added",
  };
};
